import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Calendar, User } from "lucide-react";
import { useAuth, API } from "../App";
import axios from "axios";

const TopNav = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${API}/notifications`, {
        withCredentials: true,
      });
      setNotifications(response.data);
    } catch (error) {
    }
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  return (
    <header className="top-nav px-5 py-3.5" data-testid="top-nav">
      <div className="flex items-center justify-between max-w-5xl mx-auto">
        <Link to="/dashboard" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <img src="/logo192.png" alt="Explorio" className="w-8 h-8 lg:w-10 lg:h-10 rounded-lg shadow-lg group-hover:shadow-cyan-500/20 transition-shadow" />
          <div>
            <span className="text-lg lg:text-xl font-bold font-heading text-white tracking-tight block">Explorio</span>
            {user && (
              <span className="text-xs lg:text-sm text-cyan-400/80 font-medium" data-testid="greeting-text">
                {getGreeting()}, {user.name?.split(" ")[0] || "Traveler"}
              </span>
            )}
          </div>
        </Link>
        
        <div className="flex items-center gap-1">
          <button
            onClick={() => navigate("/calendar")}
            className="relative p-2.5 hover:bg-white/5 rounded-xl transition-all duration-300 touch-target group"
            data-testid="calendar-button"
          >
            <Calendar className="w-5 h-5 lg:w-6 lg:h-6 text-slate-400 group-hover:text-cyan-400 transition-colors duration-300" />
            {notifications.length > 0 && (
              <span className="absolute top-2 right-2 w-2 h-2 bg-cyan-400 rounded-full shadow-lg shadow-cyan-400/50" />
            )}
          </button>
          <button
            onClick={() => navigate("/personal")}
            className="p-2.5 hover:bg-white/5 rounded-xl transition-all duration-300 touch-target group"
            data-testid="personal-button-top"
          >
            <User className="w-5 h-5 lg:w-6 lg:h-6 text-slate-400 group-hover:text-cyan-400 transition-colors duration-300" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default TopNav;
